import addiesaas, {Vue} from '../../addiesaas'
import vuestrap from '../../vuestrap'

const EventBus = window.VueEventBus
const DataFilter = window.VueDataFilter

const RocketEffect = window.RocketEffect = window.RocketEffect ||
  {addiesaas, Vue, vuestrap, EventBus, DataFilter}
export default RocketEffect
